import gql from "graphql-tag";


const oldBookingGraphQl = {
  getOldBookingDispatchDriver: gql`
    mutation CreateTrip($newTripData: NewTripInput!) {
      createTrip(newTripData: $newTripData) {
        trip {
          bookingChannel
          bookingDate
          destination {
            address
            lat
            long
            user {
              name
              phoneNumber
            }
          }
          distance
          id
          loadWeight
          orderDate
          origin {
            address
            lat
            long
            user {
              name
              phoneNumber
            }
          }
          referenceNumber
          shippingId
          status
          tripCost
          vehicleType
        }
        success
      }
    }
        `
}

const sendMessageQGL = {
  sendMessage: gql`
         mutation SendMessage($tripId: String!, $senderId: String!, $senderRole: String!, $content: String!) {
            sendMessage(input: {
              tripId: $tripId
              senderId: $senderId
              senderRole: $senderRole
              content: $content
            }) {
              message
              success
            }
          }
          `
}

 const messagesGraphQlSubcription = {
  getMessagesSub: gql`
    subscription GetMessagesSub($tripId: String!) {
    getMessagesSub(tripId: $tripId) {
      data {
        content
        seenBy
        senderId
        senderRole
        timestamp
        tripId
        id
      }
      message
      success
    }
  }
  `
};

 const getMessagesTrip = {
  getMessagesTrip: gql`
    query GetMessages($tripId: String!) {
      getMessages(tripId: $tripId) {
        message
        success
        data {
          content
          id
          seenBy
          senderId
          senderRole
          tripId
          timestamp
        }
      }
}
  `
};




export const bookingGraphQl = {
  ...oldBookingGraphQl,
  ...sendMessageQGL,
  ...messagesGraphQlSubcription,
  ...getMessagesTrip,
  getDispatchDriver: gql`
   mutation CreateBatchTrip($newTripData: NewTripInput!) {
          createBatchTrip(newTripData: $newTripData) {
            trip {
              bookingChannel
              bookingDate
              destination {
                address
                lat
                long
                user {
                  name
                  phoneNumber
                }
              }
              distance
              id
              loadWeight
              orderDate
              origin {
                address
                lat
                long
                user {
                  name
                  phoneNumber
                }
              }
              referenceNumber
              shippingId
              status
              batchementId
              tripCost
              vehicleType
            }
            success
          }
        }
        `
}
